import { Box, Heading } from "@biblioteksentralen/react";
import { isProduction, ResolvedBibliobattlesBannerData } from "@libry-content/common";
import { Pixelify_Sans } from "next/font/google";
import { useState } from "react";
import { Edit } from "../../editInSanity/EditInSanity";
import { SanityImagePreservingAspectRatio } from "../../images/SanityImagePreservingAspectRatio";
import { MissingCampaignTemplateContentBanner } from "../MissingCampaignTemplateContentBanner";

const ibmPlexMono = Pixelify_Sans({ subsets: ["latin"], weight: "500" });

export type BibliobattlesBannerProps = {
  bibliobattles: ResolvedBibliobattlesBannerData | undefined | null;
};

export const BibliobattlesViewBanner = ({ bibliobattles }: BibliobattlesBannerProps) => {
  const [backgroundHasLoaded, setBackgroundHasLoaded] = useState(false);
  const templateContent = bibliobattles?.templateContent;
  const missingContent = !templateContent?.bannerBackgroundLandingPage?.asset;

  if (missingContent) console.error("Missing necessary assets to display bibliobattles banner");

  if (missingContent && !isProduction) {
    return (
      <MissingCampaignTemplateContentBanner
        campaignName="Bibliobattles"
        templatePath="cms/structure/campaigns;bibliobattlesTemplateContent"
      />
    );
  }

  if (!templateContent) {
    return null;
  }

  return (
    <>
      <Box
        width="100%"
        maxWidth="container.lg"
        margin="0 auto"
        position="relative"
        overflow="hidden"
        className={ibmPlexMono.className}
        // Headers ovveride font-family unless we specify them using the sx prop
        css={{ "& h1,h2": ibmPlexMono.style }}
        color="#FFE560"
        textShadow="0px .1em .2em black"
      >
        <SanityImagePreservingAspectRatio
          image={templateContent?.bannerBackgroundSeparatePage}
          resolution={1200}
          _groupHover={{}}
          width="100%"
          minWidth="30rem"
          customNextImageProps={{ onLoad: () => setBackgroundHasLoaded(true) }}
          borderRadius={{ base: "none", lg: "xl" }}
          position="relative"
          left="50%"
          transform="translateX(-50%)"
        />
        {backgroundHasLoaded && (
          <Box
            zIndex={2}
            paddingTop="0.5rem"
            alignSelf="flex-start"
            padding={{ base: "1rem", md: "2rem" }}
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
          >
            <Heading
              as="h1"
              fontSize={{ base: "2rem", lg: "5rem" }}
              whiteSpace="nowrap"
              // eslint-disable-next-line i18next/no-literal-string
            >
              Bibliobattles
            </Heading>
          </Box>
        )}
      </Box>
      <Box marginTop="0 !important" zIndex={2}>
        {bibliobattles && <Edit doc={bibliobattles} margin="auto" />}
      </Box>
    </>
  );
};
